import React from "react";
import Plot from 'react-plotly.js'
import pca_data from "../data/pca_data.csv";
import * as d3 from "d3";
import { Tabs, Tab } from "react-bootstrap";
import PCA2D from './pca/PCA2D.js';
import PCA3D from './pca/PCA3D.js';

const PCAGraph = () => {

      function onClickGene(geneData) {
          if (geneData.points[0] !== null && geneData.points[0] !== undefined) {
              const url = 'https://ncbi.nlm.nih.gov/gene/?term=' + geneData.points[0].text;
              window.open(url, "_blank")
          }
      }

      return (
      <Tabs defaultActiveKey="2D" id="pca-graph-tab" style={{ width: '50%', margin: '0 auto', paddingTop: '2%', fontWeight: 'bold' }}>
        <Tab eventKey="2D" title="2D PCA Plot" style={{ marginTop: '2%' }}>
          <Plot
            data={PCA2D.data}
            layout={{
              width: 800,
              height: 700,
              title: `2D PCA Plot of Preprocessed Gene Sets`
            }}
            onClick={onClickGene}
          />
        </Tab>
        <Tab eventKey="3D" title="3D PCA Plot" style={{ marginTop: '2%' }}>
          <Plot
            data={PCA3D.data}
            layout={{
              width: 800,
              height: 700,
              title: `3D PCA Plot of Preprocessed Gene Sets`
            }}
            onClick={onClickGene}
          />
        </Tab>
      </Tabs>
    );
    
};

export default PCAGraph;
